import { useEffect, useState } from 'react'
import { Address } from '../runtimeComponent/subComponent/AddressSearchComponent';
import axios from 'axios';

export interface AddressSearchResponse { 
    mailAddressChoice: {
        addressDetails?: Address;
        addressAlternatives?: string[];
    } | Address[];
    status: string;
}

interface AddressSearchRequest {
    addressString: string;
    displayAddressLines: boolean;
    optionSelected: string;
    province: string;
}

export const useAddressSearch  = (address: string, searchUrl: string, isNoStreetNoAddress=false, ignorSearch=false, accessToken?: string): {
    data: any; // AddressSearchResponse,
    setSearchingAddress: (arg: string) => void;
    loading: boolean;
    error: any;
} => {
    const [data, setData] = useState<AddressSearchResponse>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string|undefined>();
    const [searchingAddress, setSearchingAddress] = useState(address);

    useEffect(() => {
        if (!searchingAddress || ignorSearch) {
            setLoading(false);
            return () => {};   
        }
        const request:AddressSearchRequest = {
            addressString: searchingAddress,
            displayAddressLines: true,
            optionSelected: '',
            province: 'ON'
        }


        //const  searchAddress = async (address: string, url: string) => {
        const searchAddress = setTimeout(async () => {
            const headers = { "Content-Type": "application/json" };
            if (accessToken) {
                headers['Authorization'] = `Bearer ${accessToken}`;
            };

            try {
                if (!isNoStreetNoAddress) {
                    const result = await axios.post(searchUrl, request, {headers});
                    if (/OK/i.test(result.data?.status)) {
                        setData(result.data);
                    } else {
                        setError(result.data?.errMsg || 'Address Search Failed');
                    }
                } else {
                    if ((/[a-z][0-9][a-z]\s*[0-9][a-z][0-9]/i).test(address)) {
                        const result = await axios.post(process.env.POSTAL_CODE_LOOKUP_URL, {postalCode: address}, {headers});
                        if (/OK/i.test(result.data?.status)) {
                            setData(result.data);
                        } else {
                            setError(result.data?.errMsg || 'postal code search failed');
                        }
                    } else {
                        setError('postal code is not valid');
                    }
                }
                setLoading(false);
            } catch (err) {
                console.error(`search address failed: ${err.message}`);
                setLoading(false);
                setError(err);
            }
        }, 500);
        return () => {clearTimeout(searchAddress)}
    }, [searchingAddress]);

    return { data, loading, error, setSearchingAddress };
};
